import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Observable, filter, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { MsgModel } from '../msg/model/msg.model';

@Component({
    selector: 'input-password-confirm',
    templateUrl: './input-password-confirm.component.html',
    styleUrls: ['./input-password-confirm.component.scss']
})
export class InputPasswordConfirmComponent implements OnInit {
    @Input() matLabel: string = 'Confirm Password';
    @Input() placeholder: string = 'Confirm Password';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;
    @Input() targetControlName!: string;

    @Input() passwordToConfirm!: string;

    hide: boolean = true;
    isLoading: boolean = false;
    msg!: MsgModel;

    passwordControl: any;
    passwordConfirmControl: any;
    passwordConfirmOptions!: Observable<any>;

    minCharacters: number = 1;

    constructor() {}

    ngOnInit(): void {
        this.passwordControl = <UntypedFormControl>this.form.get(this.targetControlName);
        this.passwordConfirmControl = <UntypedFormControl>this.form.get(this.controlName);

        this.passwordConfirmOptions = this.passwordConfirmControl.valueChanges.pipe(
            // only search if search string is >= 1 characters
            //filter((text: string) => text !== null && text.length >= this.minCharacters),
            //debounceTime(500),
            distinctUntilChanged(),
            map((value) => this.checkPassword())
        );
    }

    checkPassword() {
        this.passwordConfirmControl.setErrors(this.passwordControl.value === this.passwordConfirmControl.value ? null : { confirmPassword: true });

        if (this.passwordControl.value === this.passwordConfirmControl.value) {
            this.msg = { SUCCESS: true };
        } else {
            this.msg = { MSG: 'Please confirm your password.', SUCCESS: false };
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.passwordControl && this.passwordConfirmControl) {
            this.checkPassword();
        }
        // You can also use categoryId.previousValue and
        // categoryId.firstChange for comparing old and new values
    }

    toggleHide() {
        this.hide = !this.hide;
    }
}
